export class ValidationMessages
{

    static unknownValue(value:string, type:Function):string
    {
        let name = (<any>type).name;
        return `Could not determine value from ${value}. Please specify a valid value for ${name}`;
    }

    static nonEmpty(type:Function):string
    {
        let name = (<any>type).name;
        return `Please specify a non-empty value for ${name}`;
    }

    static nonEmptyValue(valueIndex:number, type:Function):string
    {
        let name = (<any>type).name;
        let valueStr = ValidationMessages._ordinalSuffixOf(valueIndex);

        return `Please specify a non-empty ${valueStr} value for ${name}`;
    }

    static needCommaSeparatedValues(numValues:number, type:Function):string
    {
        let name = (<any>type).name;
        return `Please specify ${numValues} values separated by a ',' for ${name}`;
    }

    static needCommaSeparatedValuesRange(numValues:number, maxNumValues:number, type:Function):string
    {
        let name = (<any>type).name;
        return `Please specify between ${numValues} and ${maxNumValues} values separated by a ',' for ${name}`;
    }

    static needNumberInRange(givenValue:any, minValue:number, maxValue:number, type:Function):string
    {
        let name = (<any>type).name;
        return `Could not convert ${givenValue} to a number in the ${minValue} to ${maxValue} range for ${name}`;
    }

    static needNumber(givenValue:any, type:Function):string
    {
        let name = (<any>type).name;
        return `Could not convert ${givenValue} to a number for ${name}`;
    }

    // From: http://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
    private static _ordinalSuffixOf(i:number)
    {
        const j = i % 10,
            k = i % 100;

        if( j == 1 && k != 11 )
            return i + 'st';

        if( j == 2 && k != 12 )
            return i + 'nd';

        if( j == 3 && k != 13 )
            return i + 'rd';

        return i + 'th';
    }
}
